<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          :config="config"
          @references="references"
          hide-create>
          <template slot='headerActions'>
            <small>Please contact technical support to add a new provider</small>
          </template>
        </app-table>

        <v-dialog
          v-model="openReference"
          max-width="800px">
          <app-table
            v-if="openReference"
            :config="referenceConfig"
            :hidden-fields="{ provider_id: provider.id }"
            :filters="{ provider_id: provider.id }"
            :subtitle="provider.name"
            modal
            no-search
            hide-upsert
            :inline-upsert="user.role !== 'EMN Estimates' "
            title="Provider references"
            @close="openReference=false" />

        </v-dialog>


      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import referenceConfig from './config_reference.js'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      config,
      referenceConfig,
      openReference: false,
      provider: {}
    }
  },
  computed: mapState(['user']),
  methods: {
    references (provider) {
      this.provider = provider
      this.openReference = true
    }
  }
}
</script>
